import { PERF_DEBUG } from "../debug-flags";

/**
 * Record the input event time, then measure the delta to the next paint
 * using double-rAF (first rAF fires before paint, second rAF fires after the
 * browser commits the frame).
 *
 * Logs `[perf:input] label=<label> Δ=<N>ms` when PERF_DEBUG is enabled.
 * No-op otherwise — zero overhead in normal use.
 *
 * Usage:
 *   onKeyDown={(e) => { markInput("composer:keydown"); ... }}
 */
export function markInput(label: string): void {
  if (!PERF_DEBUG) return;
  if (
    typeof performance === "undefined" ||
    typeof requestAnimationFrame === "undefined"
  ) {
    return;
  }

  const start = performance.now();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const delta = performance.now() - start;
      console.debug(`[perf:input] label=${label} Δ=${Math.round(delta)}ms`);
    });
  });
}
